"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PopUpAction = function (_a) {
    var _b = _a.showOnHover, showOnHover = _b === void 0 ? true : _b, actions = _a.actions, direction = _a.direction, popupStyle = _a.popupStyle, text = _a.text, testId = _a.testId, buttonStyle = _a.buttonStyle;
    var _c = React.useState(false), hoverPopupOpen = _c[0], setHoverPopupOpen = _c[1];
    var _d = React.useState(false), clickPopupOpen = _d[0], setClickPopupOpen = _d[1];
    var _e = React.useState(false), isConfirmOpen = _e[0], setIsConfirmOpen = _e[1];
    var _f = React.useState(null), selectedAction = _f[0], setSelectedAction = _f[1];
    var _g = React.useState(0), centerX = _g[0], setCenterX = _g[1];
    var _h = React.useState(0), centerY = _h[0], setCenterY = _h[1];
    var buttonTrigger = React.useRef();
    var centerContent = function () {
        if (buttonTrigger && buttonTrigger.current) {
            var _a = buttonTrigger.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
            setCenterX(left + width / 2);
            setCenterY(top_1 + height / 2);
        }
    };
    var handleBodyClick = function (e) {
        centerContent();
        var isTargetingPopup = e.target.closest('.Popup') != null;
        if (!isTargetingPopup) {
            setHoverPopupOpen(false);
            setIsConfirmOpen(false);
            setClickPopupOpen(false);
        }
    };
    React.useEffect(function () {
        if (clickPopupOpen || hoverPopupOpen) {
            document.body.addEventListener('click', handleBodyClick, true);
            window.addEventListener('scroll', centerContent, true);
        }
        else {
            document.body.removeEventListener('click', handleBodyClick, true);
            window.removeEventListener('scroll', centerContent, true);
        }
    }, [clickPopupOpen, hoverPopupOpen, handleBodyClick, centerContent]);
    var handleActionClick = function (action) {
        if (action.requiresConfirmation) {
            setIsConfirmOpen(true);
            setSelectedAction(action);
        }
        else {
            action.callback();
        }
    };
    var togglePopup = function (e) {
        e.stopPropagation();
        setHoverPopupOpen(false);
        setClickPopupOpen(!clickPopupOpen);
        centerContent();
    };
    var _j = selectedAction || {}, _k = _j.callback, callback = _k === void 0 ? undefined : _k, _l = _j.confirmationText, confirmationText = _l === void 0 ? undefined : _l, _m = _j.requiresConfirmation, requiresConfirmation = _m === void 0 ? undefined : _m;
    var dirString = direction.reduce(function (acc, cur) {
        return "".concat(acc, " Popup-container--").concat(cur);
    }, '');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": testId, className: "Popup ".concat(showOnHover && 'Popup--hover'), onMouseEnter: function () {
                centerContent();
                if (showOnHover)
                    setHoverPopupOpen(true);
            }, onMouseLeave: function () { return showOnHover && setHoverPopupOpen(false); } },
            React.createElement("button", { ref: buttonTrigger, type: "button", className: "Button Button--small", onClick: function (e) { return togglePopup(e); }, style: buttonStyle }, text),
            React.createElement("div", { className: "Popup-container ".concat(dirString, " is-open ").concat((hoverPopupOpen || clickPopupOpen) ? '' : 'u-hidden'), style: __assign(__assign({}, popupStyle), { left: "".concat(centerX, "px"), top: "".concat(centerY, "px") }) },
                React.createElement("div", { className: "Popup-content" },
                    React.createElement("div", { className: "u-textLeft" }, actions.map(function (action, i) {
                        return (React.createElement("div", { key: i },
                            React.createElement("button", { type: "button", tabIndex: 0, className: "u-padEndsSm u-padSidesMd", style: {
                                    cursor: 'pointer',
                                    appearance: 'none',
                                    border: 'none',
                                    background: 'none',
                                    width: '100%',
                                    textAlign: 'left',
                                }, onClick: function () { return handleActionClick(action); } }, action.text),
                            React.createElement("hr", { className: "Divider u-spaceEndsNone" })));
                    }))))),
        React.createElement("div", { className: "Popup" },
            React.createElement("div", { className: "Popup-container Popup-container--overlay ".concat(requiresConfirmation && isConfirmOpen ? 'is-open' : ''), style: {
                    left: "".concat(centerX, "px"),
                    top: "".concat(centerY, "px"),
                } },
                React.createElement("div", { className: "Popup-content u-padMd" },
                    React.createElement("h3", { className: "u-spaceBottomSm u-textCenter" }, "Are you sure?"),
                    React.createElement("p", { className: "u-textLeft" }, confirmationText),
                    React.createElement("div", { className: "u-textCenter u-spaceTopMd" },
                        React.createElement("button", { type: "button", onClick: function () {
                                setIsConfirmOpen(false);
                                setSelectedAction(null);
                            }, className: "u-spaceRightSm Button Button--negative" }, "Cancel"),
                        React.createElement("button", { type: "button", onClick: function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                if (callback)
                                    callback(args);
                                setIsConfirmOpen(false);
                                setSelectedAction(null);
                            }, className: "Button Button--primary" }, "Confirm")))))));
};
exports.default = PopUpAction;
